import { AxiosRequestConfig } from 'axios';
import { api } from './api';

interface RequestOptions<T> {
  method: 'get' | 'post' | 'put' | 'patch' | 'delete';
  url: string;
  data?: T;
  config?: AxiosRequestConfig;
  onUploadProgress?: (progressEvent: ProgressEvent) => void;
}

export const request = async <T>({
  method,
  url,
  data,
  config,
  onUploadProgress,
}: RequestOptions<T>): Promise<T> => {
  try {
    const finalConfig = { ...config, onUploadProgress };

    if (data instanceof FormData) {
      if (!finalConfig.headers) {
        finalConfig.headers = {};
      }
      (finalConfig.headers as any)['Content-Type'] = undefined;
    }

    const response = await api({
      method,
      url: `api${url}`,
      ...(method.toLowerCase() === 'get' ? { params: data } : { data }),
      ...finalConfig,
    });
    return response.data as T;
  } catch (error) {
    throw error;
  }
};

export const requestTable = async ({
  endpoint,
  params,
}: {
  endpoint: string;
  params: any;
}): Promise<any> => {
  try {
    const { offset, limit, orderBy, sort, ...restParams } = params;

    const queryParams = new URLSearchParams({
      offset: String(offset),
      limit: String(limit),
      ...(orderBy && { orderBy: JSON.stringify(orderBy) }),
      ...(sort && { sort }),
    });

    Object.entries(restParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        queryParams.append(key, String(value));
      }
    });

    const url = `${endpoint}?${queryParams.toString()}`;

    const response = await api.get(url);
    return response?.data;
  } catch (error: any) {
    console.error(`Error in GET request to ${endpoint}:`, error);
    throw error;
  }
};
